<mat-form-field appearance="outline" style="width: 100%;">
  <input matInput
         [matDatepicker]="picker"
         [placeholder]="placeholder"
         [disabled]="disabled"
         [(ngModel)]="value"
         (ngModelChange)="onModelChange($event)"
         (focus)="picker.open()"
         (click)="picker.open()">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker
                  [startAt]="value"
                  [startView]="'month'"
                  [minDate]="minDate"
                  [maxDate]="maxDate">
  </mat-datepicker>
</mat-form-field>
